module.exports = __webpack_public_path__ + "img/receiptUser.9b3ffe82.jpg";